import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { LeadsService } from 'src/app/_service/leads.service';
import { MiscService } from '../../_service/misc.service';
import { SharedService } from '../../_service/shared.service';
declare var $: any;


@Component({
  selector: 'app-bd-wise-report',
  templateUrl: './bd-wise-report.component.html',
  styleUrls: ['./bd-wise-report.component.css']
})
export class BdWiseReportComponent implements OnInit {
  @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;
  myrole: string; loaded: boolean = false;
  bd_report_loading: boolean = false; bdReportList = []; bds = []; bds_copy = []; bd: string; start_date:string='';end_date:string='';
  constructor(public miscapi: MiscService, private sharedapi: SharedService, private leadapi: LeadsService,) {
    this.sharedapi.getRole().subscribe((item: string) => { this.myrole = item; });
    this.myrole = localStorage.getItem('role');
  }

  ngOnInit(): void {
    if (this.myrole == '1') {
      this.getbds();
      this.getBdReportList();
    }
  }

  dateRangeChange(date1,date2)
  {
      if(date2.value)
      {
          this.start_date = date1.value;
          this.end_date = date2.value;
      }
  }

  clearDate()
  {
      this.dateRangeStart.nativeElement.value = "";
      this.dateRangeEnd.nativeElement.value = "";
      this.start_date = '';
      this.end_date = '';
      this.getBdReportList();
  }

  async getBdReportList() {
    let qString = 'bd=' + this.bd +'&date_range='+this.start_date+'-'+this.end_date;
    this.loaded = false;
    this.bd_report_loading = true;
    this.bdReportList = [];
    await this.miscapi.getBdWiseReportData(qString).subscribe((data: any) => {
      this.bd_report_loading = false;
      this.loaded = true;
      if (data.status) {
        this.bdReportList = data.data;
      } else {
        this.sharedapi.presentToast('Something went wrong. Please try again.');
      }
    }, error => {
      this.sharedapi.checkError(error);
      this.loaded = true;
    });
  }

  async getbds(status = 1) {
    this.leadapi.getbdsExcludingDental(status).subscribe((data: any) => {
      if (data.status) {
        this.bds = data.data;
        this.bds_copy = this.bds;
      } else {
        this.bds = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }


  setSearchValue(type) {
    if (type == 'bds') {
      $("#bd_search").val('');
      $("#bd_search").focus();
      this.bds = this.bds_copy;
    }
  }

  searchOnSelect(searchtText: string, type) {
    if (type == 'bds') {
      this.bds = this.sharedapi.searchData(searchtText, this.bds_copy, "name");
    }
  }

  resetFilters() {
    this.bd = '';
    this.clearDate();
    this.getBdReportList();
  }


}
